import { Center, Spinner } from "@chakra-ui/react";
import Logo from "components/elements/Logo";

const LoadingLogo = () => {
  return (
    <Center maxW="300px" mx="auto" flexDir="column" h="100vh">
      <Logo justify="center" />
      <Spinner
        thickness="4px"
        speed="0.65s"
        emptyColor="gray.200"
        color="primary"
        size="xl"
      />
    </Center>
  );
};

export default LoadingLogo;
